var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{attrs:{"type":"number","min":"0"},model:{value:(_vm.limit_study_plan.restriction_value),callback:function ($$v) {_vm.$set(_vm.limit_study_plan, "restriction_value", $$v)},expression:"limit_study_plan.restriction_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }